export default __webpack_public_path__ + "static/media/oil.dba2b8e6.svg";